// payment_links.payment_methods is "CC-ACH-WTO" on current links and "C_A_P"
// on legacy ones. Google Pay / Apple Pay codes have no tab of their own.
const LINK_METHOD_NAMES: Record<string, string> = {
  CC: "Card",
  C: "Card",
  ACH: "Bank",
  A: "Bank",
  PP: "PayPal",
  P: "PayPal",
  WTO: "Wire",
  WT: "Wire",
  W: "Wire",
  CAPP: "Cash App Pay",
  AMZP: "Amazon Pay",
};

// Returns null when the link carries no usable list, meaning the link adds no
// restriction on top of the cluster's own settings.
export const getLinkAllowedMethodNames = (
  paymentMethods?: string | null
): Set<string> | null => {
  if (typeof paymentMethods !== "string") return null;

  const names = new Set<string>();
  paymentMethods
    .toUpperCase()
    .split(/[-_]/)
    .forEach((code) => {
      const name = LINK_METHOD_NAMES[code.trim()];
      if (name) names.add(name);
    });

  return names.size > 0 ? names : null;
};

// A method is offered only when both the cluster settings (already applied to
// `methods`) and the link allow it. If the two share nothing, the cluster's
// list is kept so the customer is never left without a way to pay.
export const filterMethodsAllowedByLink = <T extends { name: string }>(
  methods: T[],
  paymentMethods?: string | null
): T[] => {
  const allowedNames = getLinkAllowedMethodNames(paymentMethods);
  if (!allowedNames) return methods;

  const allowedMethods = methods.filter((method) =>
    allowedNames.has(method.name)
  );

  return allowedMethods.length > 0 ? allowedMethods : methods;
};
